import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { List } from "immutable";
import { IdType } from "common/types";
import { IMetaPaginationData } from "common/records/MetaPagination";

export const FETCH_MODEL = "@idsManagement/FETCH_MODEL";
export const RECEIVE_MODEL = "@idsManagement/RECEIVE_MODEL";
export const PUSH_ID = "@idsManagement/PUSH_ID";
export const PUSH_IDS = "@idsManagement/PUSH_IDS";
export const PREPEND_ID = "@idsManagement/PREPEND_ID";
export const REPLACE_ID = "@idsManagement/REPLACE_ID";
export const REMOVE_ID = "@idsManagement/REMOVE_ID";
export const REMOVE_IDS = "@idsManagement/REMOVE_IDS";
export const CLEAR_PAGE = "@idsManagement/CLEAR_PAGE";
export const SET_BY_ATTR_PATH = "@idsManagement/SET_BY_ATTR_PATCH";
export const SET_DIRTY_IDS = "@idsManagement/SET_DIRTY_IDS";
export const ON_SORT_END = "@idsManagement/ON_SORT_END";
export const SET_MODEL_LOADED = "@idsManagement/SET_MODEL_LOADED";

export const IdsManagementActions = {
  fetchModel: (modelName: string, queryParams?: any) => createAction(FETCH_MODEL, { modelName, queryParams }),
  receiveModel: (modelName: string, ids: List<IdType>, metaPagination?: Partial<IMetaPaginationData>) =>
    createAction(RECEIVE_MODEL, {
      modelName,
      ids,
      metaPagination,
    }),
  pushId: (id: IdType, modelName: string) => createAction(PUSH_ID, { id, modelName }),
  pushIds: (ids: List<IdType>, modelName: string) => createAction(PUSH_IDS, { ids, modelName }),
  prependId: (id: IdType, modelName: string) => createAction(PREPEND_ID, { id, modelName }),
  replaceId: (replacedId: IdType, newId: IdType, modelName: string) =>
    createAction(REPLACE_ID, { replacedId, newId, modelName }),
  removeId: (removeId: IdType, modelName: string) => createAction(REMOVE_ID, { removeId, modelName }),
  removeIds: (ids: List<IdType>, modelName: string) => createAction(REMOVE_IDS, { ids, modelName }),
  clearPage: (modelName: string) => createAction(CLEAR_PAGE, { modelName }),
  setByAttrPath: (id: IdType, modelName: string, attrPath: string[], value: IdType, customPath?: string[]) =>
    createAction(SET_BY_ATTR_PATH, { id, modelName, attrPath, value, customPath }),
  setDirtyIds: (ids: List<IdType> | null) => createAction(SET_DIRTY_IDS, { ids }),
  onSortEnd: (
    modelName: string,
    oldIndex: number,
    newIndex: number,
    attrPath: string[] = ["sort_order"],
    customPath: string[] | undefined = undefined, // Custom path to the ids map where records are stored
  ) => createAction(ON_SORT_END, { modelName, oldIndex, newIndex, attrPath, customPath }),
  setModelLoaded: (modelName: string) => createAction(SET_MODEL_LOADED, { modelName }),
};

export type IdsManagementActions = ActionsUnion<typeof IdsManagementActions>;
